<template>
    <div>
        <v-divider class="mb-2"/>
        <div class="d-flex justify-end">
            <v-pagination
                v-model="page"
                color="brand-lighten"
                :length="last_page"
                :total-visible="7"
                @input="changePage"
            />
        </div>
        <div class="d-flex justify-end t-body mt-4">
            Exibindo {{ pagination.from }} até {{ pagination.to }} de {{ pagination.total }}
        </div>
    </div>
</template>

<script>

export default {
    inheritAttrs: false,
    props: {
        pagination: {
            type: Object,
            required: true,
            default: null,
        },
        params: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        routePagination: {
            type: String,
            required: false,
            default: null,
        },
        routeParam: {
            required: false,
            default: null,
        }
    },
    data: (vm) => ({
        current_page: vm?.pagination?.current_page ?? 0,
        page: vm?.pagination?.current_page ?? 0,
        last_page: vm?.pagination?.last_page ?? 0,
    }),
    methods: {
        changePage(selectedPage) {
            this.sending = true

            let params = new URLSearchParams(this.params).toString()

            let action = this.routeParam
                ? this.route(this.currentRoutePagination, this.routeParam)
                : this.route(this.currentRoutePagination)
            action += `?page=${selectedPage}`
            action += params ? `&${params}` : ''

            this.redirect(action)
        },
    },

    computed: {
        hasPagination() {
            return this.last_page > 1
        },

        currentRoutePagination() {
            return this.routePagination ?? this.currentRouteName
        }
    },
}
</script>